import React, { useEffect, useState } from 'react';
import { Typography, Input, Row, Col, Button, Space, message } from 'antd';
import { Screen } from '../../components/UI/Screen.component';
import { Container } from '../../components/UI/Container.component';
import { ScreenHeader } from '../../components/UI/ScreenHeader.component';
import {useParams} from 'react-router-dom';
import { Section } from '../../components/UI/Section.component';
import { EditBranchForm } from '../../components/Dashboard/Branch/EditBranchForm';
import BranchService from '../../services/branch.service';
const { Title } = Typography;

export const EditBranchScreen = () => {

    const params = useParams();
    const [branch, setBranch] = useState({})
    const [isLoaded, setIsLoaded] = useState(false)
    
    useEffect(() => {
        let data =  {id: params.id};
        BranchService.getBranch(data).then(
          (response) => {
            setBranch(response.data.branch);
            setIsLoaded(true);
          },
          (error) => {
              // console.log(error.response.data.message)
          }
        );
    }, [])


    return(
        <>
            <Screen id="">
                <Container >
                    <Section style={{width: '600px'}}>
                        <Row justify="space-between " style={{gap:"10px",}}>
                            <Col>
                                { isLoaded && <EditBranchForm branch={branch} branchID={params.id} />}
                            </Col>
                        </Row>
                    </Section>
                </Container>
            </Screen>
        </>
    )
}
